<template>
  <div>
    <div v-if="loading" class="loading-indicator">
      <p>Carregando...</p>
    </div>
    <div v-else>
      <form @submit.prevent="submitForm">
        <!-- Placa -->
        <b-form-group label="Placa" label-for="plate" class="mb-3">
          <multiselect
            v-if="!isEditMode"
            id="plate"
            v-model="selectedPlateOption"
            :options="platesOptions"
            :searchable="true"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :multiple="false"
            placeholder="Selecione a placa"
            label="text"
            track-by="value"
            class="multiselect-custom"
            required
            @input="handlePlateSelect"
          />
          <b-form-input v-else id="plate" v-model="form.plate" disabled>
          </b-form-input>
        </b-form-group>

        <!-- Tipo da Revisão -->
        <b-form-group
          label="Tipo da Revisão"
          label-for="revisionType"
          class="mb-3"
        >
          <multiselect
            v-if="!isEditMode"
            id="revisionType"
            v-model="selectedRevisionOption"
            :options="revisionOptions"
            :searchable="true"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :multiple="false"
            placeholder="Selecione o tipo de revisão"
            label="text"
            track-by="value"
            class="multiselect-custom"
            required
            @input="handleRevisionSelect"
          />
          <b-form-input
            v-else
            id="revisionType"
            v-model="form.description"
            disabled
          ></b-form-input>
        </b-form-group>

        <!-- Marcador -->
        <b-form-group label="Marcador ()" label-for="measurer" class="mb-3">
          <b-form-input
            type="number"
            id="measurer"
            v-model="form.measurer"
            required
          />
        </b-form-group>

        <!-- Botões de Ação -->
        <div class="d-flex justify-content-end mt-3">
          <b-button size="sm" type="submit" variant="green">
            {{ isEditMode ? "Atualizar" : "Registrar" }}
          </b-button>
          <b-button
            size="sm"
            variant="secondary"
            @click="$emit('close')"
            class="ml-2"
          >
            Cancelar
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      required: true
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        ...this.model,
        vehicleId: this.model.vehicleId || null,
        plate: this.model.plate || "",
        measurer: this.model.measurer || "",
        vehicleRevisionId: this.model.vehicleRevisionId || ""
      },
      platesOptions: [],
      selectedPlateOption: null,
      revisionOptions: [],
      selectedRevisionOption: null,
      loading: true
    };
  },
  created() {
    this.initializeComponent();
  },
  watch: {
    model(newModel) {
      this.form = {
        ...newModel,
        vehicleId: newModel.vehicleId || null,
        plate: newModel.plate || "",
        measurer: newModel.measurer || "",
        vehicleRevisionId: newModel.vehicleRevisionId || ""
      };
      this.initializeSelectedPlate();
      this.initializeSelectedRevision();
    }
  },
  methods: {
    async initializeComponent() {
      try {
        await this.getAllVehiclePlate();
        this.initializeSelectedPlate();
      } catch (error) {
        console.error("Erro ao inicializar o componente:", error);
      } finally {
        this.loading = false;
      }
    },
    async submitForm() {
      try {
        // Validar e formatar os dados do formulário
        const payload = {
          ...this.form,
          measurer: parseInt(this.form.measurer, 10),
          vehicleRevisionId: this.form.vehicleRevisionId
            ? Number(this.form.vehicleRevisionId)
            : null,
          vehicleId: this.form.vehicleId ? Number(this.form.vehicleId) : null
        };

        if (this.isEditMode) {
          if (!payload.entryId && !payload.exitId) {
            throw new Error(
              "ID de entrada e saída são necessário para atualização."
            );
          }
          await this.$apiVehicle.post(`/EditRevisionDone/`, payload);
        } else {
          await this.$apiVehicle.post("/CreateRevisionDone/", payload);
        }

        this.$emit("success");
      } catch (error) {
        console.error(
          this.isEditMode
            ? "Erro ao atualizar entrada de manutenção:"
            : "Erro ao registrar entrada de manutenção:",
          error
        );
        this.$emit("error", error); // Emite um evento de erro para o componente pai, se necessário
      }
    },
    async getAllVehiclePlate() {
      try {
        const response = await this.$apiVehicle.get("/GetPlatesWithRevision/");
        if (Array.isArray(response.data.result)) {
          this.platesOptions = response.data.result.map(item => ({
            text: item.text,
            value: Number(item.value)
          }));
          this.initializeSelectedPlate();
        } else {
          console.error(
            "Esperava um array, mas recebeu:",
            response.data.result
          );
          this.platesOptions = [];
        }
      } catch (error) {
        this.verifyExceptionType(error);
        throw error;
      }
    },
    async getDropdownRevisionByPlate(vehicleId) {
      try {
        const response = await this.$apiVehicle.get(
          `/vehicleModel/listDropdown/revisions/${vehicleId}`
        );
        if (Array.isArray(response.data)) {
          this.revisionOptions = response.data.map(item => ({
            text: item.text,
            value: Number(item.value)
          }));
          this.initializeSelectedRevision();
        } else {
          console.error("Esperava um array, mas recebeu:", response.data);
          this.revisionOptions = [];
        }
      } catch (error) {
        this.verifyExceptionType(error);
        throw error;
      }
    },
    handlePlateSelect(selectedOption) {
      if (selectedOption) {
        this.form.plate = selectedOption.text;
        this.form.vehicleId = Number(selectedOption.value);
        this.getDropdownRevisionByPlate(this.form.vehicleId);
      } else {
        this.form.plate = "";
        this.form.vehicleId = null;
        this.revisionOptions = [];
        this.selectedRevisionOption = null;
      }
    },
    handleRevisionSelect(selectedOption) {
      if (selectedOption) {
        this.form.vehicleRevisionId = selectedOption.value;
        this.form.description = selectedOption.text;
      } else {
        this.form.vehicleRevisionId = null;
        this.form.description = "";
      }
    },
    initializeSelectedPlate() {
      if (this.form.plate && this.form.vehicleId !== null) {
        this.selectedPlateOption = this.platesOptions.find(
          option =>
            option.text === this.form.plate &&
            option.value === this.form.vehicleId
        );
        if (!this.selectedPlateOption) {
          console.warn(
            `Placa ${this.form.plate} com ID ${this.form.vehicleId} não encontrada nas opções.`
          );
        } else {
          this.getDropdownRevisionByPlate(this.form.vehicleId);
        }
      } else {
        this.selectedPlateOption = null;
      }
    },
    initializeSelectedRevision() {
      if (this.form.vehicleRevisionId) {
        this.selectedRevisionOption =
          this.revisionOptions.find(
            option => option.value === Number(this.form.vehicleRevisionId)
          ) || null;
      } else {
        this.selectedRevisionOption = null;
      }
    },
    verifyExceptionType(error) {
      console.error("Erro na requisição:", error);
    }
  }
};
</script>

<style scoped>
.multiselect-custom {
  width: 100%;
}
.ml-2 {
  margin-left: 0.5rem;
}
.loading-indicator {
  text-align: center;
  padding: 20px;
  font-size: 1.2em;
  color: #555;
}
</style>
